var React = require('react');

function EmailChecked (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.1 12H1.5C.675 12 0 11.325 0 10.5l.007-9C.007.675.675 0 1.5 0h12c.825 0 1.5.675 1.5 1.5v4.6a5.002 5.002 0 0 0-3.9 5.9zm2.4-9l-6 3.75L1.5 3V1.5l6 3.75 6-3.75V3zm2.36 8.523l-2.133-2.177-.727.736L15.86 13 22 6.736 21.279 6l-5.419 5.523z","fill":"currentColor","fillRule":"evenodd"}));
}

EmailChecked.defaultProps = {"width":"22","height":"13","viewBox":"0 0 22 13"};

module.exports = EmailChecked;

EmailChecked.default = EmailChecked;
